import { Component } from '@angular/core';

@Component({
  selector: 'app-deletegroup',
  templateUrl: './deletegroup.component.html',
  styleUrls: ['./deletegroup.component.scss']
})
export class DeletegroupComponent {

}
